import React from 'react';
import { SegmentedButton } from '@/contasis';
import type { ProductType } from '@/hooks/productos/useProductoFormulario';

interface ProductTypeSelectorProps {
  productType: ProductType;
  onChange: (type: ProductType) => void;
  showCheck?: boolean;
  renderCheck?: (className?: string) => React.ReactNode;
}

export const ProductTypeSelector: React.FC<ProductTypeSelectorProps> = ({
  productType,
  onChange,
  showCheck,
  renderCheck
}) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="block text-ui-sm font-medium text-tertiary">Tipo de producto</label>
        {showCheck && renderCheck?.()}
      </div>
      <SegmentedButton
        size="sm"
        variant="outlined"
        value={productType}
        onChange={(value) => onChange(value as ProductType)}
        options={[
          { value: 'BIEN', label: 'Bien' },
          { value: 'SERVICIO', label: 'Servicio' }
        ]}
      />
    </div>
  );
};
